import React, { useEffect, useRef, useState } from 'react';
import Editor from 'react-simple-code-editor';
import { ModalEditorWrapper } from './styles';
import { LineNumbers } from '../../Code/LineNumbers';
import { CodeStyles } from '../../Code/CodeStyles';
// @ts-ignore
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-okaidia.css';
var CodeEditorModal = function (_a) {
    var code = _a.code, onSubmit = _a.onSubmit, disabled = _a.disabled;
    var _b = useState(code), esseText = _b[0], setEsseText = _b[1];
    var editorRef = useRef(null);
    var lineNumbersRef = useRef(null);
    useEffect(function () {
        return function () {
            onSubmit && onSubmit(esseText);
        };
    }, [esseText, onSubmit]);
    useEffect(function () {
        var handleScroll = function () {
            if (editorRef.current && lineNumbersRef.current) {
                lineNumbersRef.current.scrollTop = editorRef.current.scrollTop;
            }
        };
        var editorNode = editorRef.current;
        if (editorNode) {
            editorNode.addEventListener('scroll', handleScroll);
        }
        return function () {
            if (editorNode) {
                editorNode.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);
    return (React.createElement(ModalEditorWrapper, { style: CodeStyles.editorWrapperModal },
        React.createElement(LineNumbers, { forwardRef: lineNumbersRef, text: esseText }),
        React.createElement("div", { style: { flex: 1, overflowY: 'auto' }, ref: editorRef },
            React.createElement(Editor, { disabled: disabled, ref: editorRef, value: esseText, onValueChange: setEsseText, highlight: function (code) { return highlight(code, languages.javascript); }, padding: 10, 
                // @ts-ignore
                style: CodeStyles.editorBoxModal }))));
};
export default CodeEditorModal;
//# sourceMappingURL=CodeEditorModal.js.mapimport React, { useEffect, useRef, useState } from 'react';
import Editor from 'react-simple-code-editor';
import { ModalEditorWrapper } from './styles';
import { LineNumbers } from '../../Code/LineNumbers';
import { CodeStyles } from '../../Code/CodeStyles';
// @ts-ignore
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-okaidia.css';
var CodeEditorModal = function (_a) {
    var code = _a.code, onSubmit = _a.onSubmit, disabled = _a.disabled;
    var _b = useState(code), esseText = _b[0], setEsseText = _b[1];
    var editorRef = useRef(null);
    var lineNumbersRef = useRef(null);
    useEffect(function () {
        return function () {
            onSubmit && onSubmit(esseText);
        };
    }, [esseText, onSubmit]);
    useEffect(function () {
        var handleScroll = function () {
            if (editorRef.current && lineNumbersRef.current) {
                lineNumbersRef.current.scrollTop = editorRef.current.scrollTop;
            }
        };
        var editorNode = editorRef.current;
        if (editorNode) {
            editorNode.addEventListener('scroll', handleScroll);
        }
        return function () {
            if (editorNode) {
                editorNode.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);
    return (React.createElement(ModalEditorWrapper, { style: CodeStyles.editorWrapperModal },
        React.createElement(LineNumbers, { forwardRef: lineNumbersRef, text: esseText }),
        React.createElement("div", { style: { flex: 1, overflowY: 'auto' }, ref: editorRef },
            React.createElement(Editor, { disabled: disabled, ref: editorRef, value: esseText, onValueChange: setEsseText, highlight: function (code) { return highlight(code, languages.javascript); }, padding: 10, 
                // @ts-ignore
                style: CodeStyles.editorBoxModal }))));
};
export default CodeEditorModal;
//# sourceMappingURL=CodeEditorModal.js.map